export const messages = {
  en: {
    communitySpaceConfirm: {
      writeOff: 'Write Off',
      writeOffPlaceholder: 'Please scan with barcode scanner to write off',
      writeOffResult: 'Write Off Result',
      writeOffTime: 'Write Off Time',
      space: 'Space',
      appointmentDate: 'Appointment Date',
      appointmentHours: 'Appointment Hours',
      appointmentPerson: 'Appointment Person',
      appointmentPhone: 'Appointment Phone',
      searchCondition: 'Search Conditions',
      search: 'Search',
      reset: 'Reset',
      writeOffOrder: 'Write Off Order',
      venue: 'Venue',
      appointmentTime: 'Appointment Time',
      remark: 'Remark',
      personNamePlaceholder: 'Enter appointment person name',
      personTelPlaceholder: 'Enter appointment phone',
      appointmentTimePlaceholder: 'Select appointment time',
      scanTip: 'Please scan barcode first',
      writeOffSuccess: 'Write off successful',
      writeOffFailed: 'Write off failed'
    }
  },
  zh: {
    communitySpaceConfirm: {
      writeOff: '核销',
      writeOffPlaceholder: '请扫码枪扫码核销',
      writeOffResult: '核销结果',
      writeOffTime: '核销时间',
      space: '场地',
      appointmentDate: '预约日期',
      appointmentHours: '预约小时',
      appointmentPerson: '预约人',
      appointmentPhone: '预约电话',
      searchCondition: '查询条件',
      search: '查询',
      reset: '重置',
      writeOffOrder: '核销订单',
      venue: '场馆',
      appointmentTime: '预约时间',
      remark: '备注',
      personNamePlaceholder: '请输入预约人',
      personTelPlaceholder: '请输入预约电话',
      appointmentTimePlaceholder: '请选择预约时间',
      scanTip: '请先扫码',
      writeOffSuccess: '核销成功',
      writeOffFailed: '核销失败'
    }
  }
}